<div class="nav-menu" role="dialog" aria-modal="true" aria-label="メニュー">
  <button type="button" class="nav-menu__faq" (click)="openFaq()" aria-label="よくある質問を開く">
    <img class="nav-menu__faq-icon" ngSrc="/page-header/question.svg" width="24" height="24" alt="" aria-hidden="true" />
    {{ masterDataStore.getDisplayTitle(UrlConstants.FAQ_URL) }}
  </button>
  <div class="nav-menu__actions">
    <button type="button" class="nav-menu__close-window" (click)="closeWindow()">
      <img class="nav-menu__close-window-icon" ngSrc="/page-header/close.svg" width="17" height="17" alt="" aria-hidden="true" />
      <span class="nav-menu__close-window-label">ウィンドウを閉じる</span>
    </button>
  </div>
</div>
